"use client";

import { StepProps, BaseFormData } from "../components/types";
import { cn } from "@/lib/utils";
import parse from "html-react-parser";
import { FormItem, FormLabel } from "@/components/ui/form";

type CriteriaStepProps<T = BaseFormData> = StepProps<T> & {
  infoBoxText?: string;
  criteriaQuestion?: string;
};

export const CriteriaStep = <T extends BaseFormData = BaseFormData>({ title, description, formOptions, infoBoxText, criteriaQuestion = "Does your business meet the below criteria?" }: CriteriaStepProps<T>) => {

  const suitabilityCriteria = (formOptions as typeof formOptions & { suitabilityCriteria?: string[] }).suitabilityCriteria || [];

  return (
    <div className="flex flex-col gap-12">

      <div className="flex flex-col gap-4">
        <h3>
          {title}
        </h3>
        {description && (
          <p className="paragraph-lg text-muted-foreground [&_strong]:text-foreground">
            {parse(description)}
          </p>
        )}
      </div>

      <FormItem className="flex flex-col gap-6">
        <FormLabel className="paragraph-base text-foreground font-bold">
          {parse(criteriaQuestion)}
        </FormLabel>
        
        <div className="border border-border rounded-3xl">
          {suitabilityCriteria.map((criterion: string, index: number) => (
            <div 
              key={index}
              className={cn(
                "w-full px-6 py-4 flex items-center gap-6 ",
                index === 0 && "rounded-t-3xl",
                index === suitabilityCriteria.length - 1 && "rounded-b-3xl",
                index < suitabilityCriteria.length - 1 && "border-b border-border"
              )}
            >
              <span className="material-symbols-outlined text-green-600">check_circle</span>
              <span className="paragraph-base text-muted-foreground">{criterion}</span>
            </div>
          ))}
        </div>
      </FormItem>

      {infoBoxText && (
        <div className="bg-muted/100 p-4 rounded-lg">
          <p className="paragraph-sm text-muted-foreground [&_strong]:text-foreground">
            {parse(infoBoxText)}
          </p>
        </div>
      )}

    </div>
  );
}; 